import { createRouter, createWebHashHistory } from 'vue-router'
import Map from './views/Map.vue'
import Admin from './views/Admin.vue'
import Feedback from './views/Feedback.vue'

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
      {
        path: '/',
        name: 'map',
        component: Map
      },
      {
        path: '/admin',
        name: 'admin',
        component: Admin
      },
      {
        path: '/feedback',
        name: 'feedback',
        component: Feedback
      },
      // For the iframe on www.gla.ac.uk:
      {
        path: '/embedded',
        name: 'embedded',
        component: Map
      }
    ]
})

export default router

